/**
 * Shared score colour helpers for readable UI (PDF task 1).
 * Numbers stay dark; colour lives in bars / badge backgrounds.
 */

export function scoreAccent(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '#76786C';
  if (n >= 8) return 'rgb(83 131 5)'; // dark green (was bright lime)
  if (n >= 6.5) return '#A16207'; // dark amber (was light yellow)
  if (n >= 5) return '#C2410C';   // dark orange
  return '#1C1917';
}

/** Fill colour for bars / tracks — still coloured, but darker than before */
export function scoreBarFill(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '#A8A99E';
  if (n >= 8) return '#65A30D';
  if (n >= 6.5) return '#CA8A04';
  if (n >= 5) return '#EA580C';
  return '#353A0A';
}

/** Soft badge background behind a dark score number */
export function scoreBadgeBg(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 'rgba(118,120,108,0.18)';
  if (n >= 8) return 'rgba(63,98,18,0.18)';
  if (n >= 6.5) return 'rgba(161,98,7,0.20)';
  if (n >= 5) return 'rgba(194,65,12,0.18)';
  return 'rgba(28,25,23,0.12)';
}
